module.exports = __webpack_public_path__ + "assets/img/00188.ca27b93e.png";